export const USER_SSO = '@uhc/utility/USER_SSO';
